// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
import "./assets/js/jquery.min.js";
import "bootstrap-rtl/bootstrap/dist/js/bootstrap.min.js";
import VsTable from "./_framework/VsTable.vue";
import store from "./store";
import VueMermaid from 'vue-mermaid'
// import cssVars from 'css-vars-ponyfill'
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import VueNoty from "vuejs-noty";
import VsInput from "./_framework/VsInput.vue";
import SearchToggleButton from "./components/SearchToggleButton.vue";
import ToggleTableActionsButton from "./components/ToggleTableActionsButton.vue";
import StockFilterButton from "./components/StockFilterButton.vue";
import SelectIntermediateProducts from "./components/SelectIntermediateProducts.vue";
import TableRowImage from "./components/TableRowImage";
import VoucherTypeSelect from "./components/VoucherTypeSelect";
import BankAccountsModalButton from "./components/BankAccountsModalButton";
import OpenAccountingDocumentButton from "./components/OpenAccountingDocumentButton";
import CustomerView from "./components/production-management/CustomerView.vue";
import InventoryDetails from "./components/production-management/InventoryDetails.vue";
import InventoryBuyDetails from "./components/production-management/InventoryBuyDetails.vue";
import InventoryDetailsPlanning from "./components/production-management/InventoryDetailsPlanning.vue";
import ProductView from "./components/production-management/ProductView.vue";
import InnerBoxToggler from "./components/production-management/InnerBoxToggler.vue";
import UserAccessesButtonLink from "./components/UserAccessesButtonLink.vue";
import OrderDetails from "./components/OrderDetails"
import Moment from "moment-jalali";
import axios from "axios";
import _nav from "./_nav";
import checkAccesses from "./checkAccess.js";
import Utils from "./_framework/utils/Utils";
import OrderForm from "./components/OrderForm.vue";
import AddPerson from "./components/AddPerson.vue";
import WorkChart from "./components/WorkChart.vue";
import WorkStatus from "./components/WorkStatus.vue";
import WorkDetailsModal from "./components/WorkDetailsModal";
import WorkFlowchart from "./components/WorkFlowchart";
import PatternDependencies from "./components/PatternDependencies.vue";
import PsSwitch from "./components/PsSwitch.vue";
import ShowProblemsModal from "./components/ShowProblemsModal.vue";
import ProblemDetails from "./components/ProblemDetails.vue"
import EditCustomerOrder from "./components/EditCustomerOrder.vue"
import CustomerOrderOperations from "./components/CustomerOrderOperations.vue";
import SellableButton from "./components/SellableButton.vue";
import OpenSupply from "./components/OpenSupply.vue"
import MiladiToShamsi from "./components/MiladiToShamsi";
import CustomEntity from "./components/CustomEntity.vue";
import ProductLastPrice from "./components/ProductLastPrice.vue";
import RawMaterialFilter from "./components/RawMaterialFilterButton.vue";
import SetProductDetails from "./components/SetProductDetails.vue";
import SetVoucherProductDetails from "./components/SetVoucherProductDetails.vue";
import Preloader from "./components/Preloader.vue";
// todo
// cssVars()
Vue.use(BootstrapVue);
Vue.use(VueMermaid);

Vue.use(VueNoty, {
  layout: "topRight",
  theme: "metroui",
  timeout: 1500
});
export const bus = new Vue();

window.checkAccess = checkAccesses.checkAccess;
window.setNavItems = checkAccesses.setNavItems;

Vue.component("vs-table", VsTable);
Vue.component("vs-input", VsInput);
Vue.component("search-toggle-button", SearchToggleButton);
Vue.component("toggle-table-actions-button", ToggleTableActionsButton);
Vue.component("stock-filter-button", StockFilterButton);
Vue.component("table-row-image", TableRowImage);
Vue.component("voucher-type-select", VoucherTypeSelect);
Vue.component("bank-accounts-modal-button", BankAccountsModalButton);
Vue.component("select-intermediate-products", SelectIntermediateProducts);
Vue.component("open-accounting-document-button", OpenAccountingDocumentButton);
Vue.component("customer-view", CustomerView);
Vue.component("inventory-details", InventoryDetails);
Vue.component("inventory-buy-details", InventoryBuyDetails);
Vue.component("inventory-details-planning", InventoryDetailsPlanning);
Vue.component("product-view", ProductView);
Vue.component("inner-box-toggler", InnerBoxToggler);
Vue.component("user-accesses-button-link", UserAccessesButtonLink);
Vue.component("order-details", OrderDetails);
Vue.component("order-form", OrderForm);
Vue.component("add-person", AddPerson);
Vue.component("work-chart", WorkChart);
Vue.component("work-status", WorkStatus);
Vue.component("work-details-modal", WorkDetailsModal);
Vue.component("edit-customer-order", EditCustomerOrder)
Vue.component("work-flowchart", WorkFlowchart);
Vue.component("pattern-dependencies", PatternDependencies);
Vue.component("ps-switch", PsSwitch);
Vue.component("show-problems-modal", ShowProblemsModal);
Vue.component("problem-details", ProblemDetails);
Vue.component("customer-order-operations", CustomerOrderOperations);
Vue.component("sellable-button", SellableButton);
Vue.component('open-supply', OpenSupply);
Vue.component('miladi-to-shamsi', MiladiToShamsi);
Vue.component('custom-entity', CustomEntity);
Vue.component("product-last-price", ProductLastPrice);
Vue.component("raw-material-filter-button", RawMaterialFilter);
Vue.component("SetProductDetails", SetProductDetails);
Vue.component("SetVoucherProductDetails", SetVoucherProductDetails);
Vue.component("Preloader", Preloader);
// Vue.component("createWork", CreateWork);

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App
  }
});

Vue.filter("formatGregorianDateToJalaali", function (val) {
  return val.substring(0, 10);
});

axios.interceptors.response.use(
  response => {
    return response;
  },
  function (error) {
    // Do something with response error

    // Throw exception
    if (error) {
      let defaultMessage = "متاسفانه خطایی رخ داده است";
      let message = "";
      if (error.data) {
        if (error.data.errors && error.data.errors.length > 0) {
          error.data.errors.map(er => {
            message = er.message || defaultMessage;
            Vue.noty.error(message);
          });
        } else {
          message = error.data.messages || defaultMessage;
          Vue.noty(message);
        }
      } else if (error.response && error.response.data) {
        if (
          error.response.data.errors &&
          error.response.data.errors.length > 0
        ) {
          error.response.data.errors.map(er => {
            message = er.message || defaultMessage;
            Vue.noty.error(message);
          });
        } else {
          message = error.response.data.messages || defaultMessage;
          Vue.noty.error(message);
        }
      }
    }
    // Access denied error
    if (
      (error && error.status && error.status === 403) ||
      (error && error.response && error.response.status === 403)
    ) {
      router.push({name: "عدم دسترسی"});
    }

    // Not authorize error
    if (
      (error && error.status && error.status === 401) ||
      (error && error.response && error.response.status === 401)
    ) {
      localStorage.removeItem("phoneNumber");
      localStorage.removeItem("token_mobile");
      localStorage.removeItem("isRegistered");
      localStorage.removeItem("auth_token");
      localStorage.removeItem("userId");
      localStorage.removeItem("accesses");
      localStorage.removeItem("postId");
      router.push({name: "ورود"});
    }
    return Promise.reject(error.response);
  }
);
let authToken = localStorage.getItem("auth_token");
if (authToken !== undefined && authToken !== "" && authToken !== null) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + authToken;
} else {
  localStorage.removeItem("phoneNumber");
  localStorage.removeItem("token_mobile");
  localStorage.removeItem("isRegistered");
  localStorage.removeItem("auth_token");
  localStorage.removeItem("userId");
  localStorage.removeItem("accesses");
  localStorage.removeItem("postId");
  _nav.items = [];
  router.push({name: "ورود"});
}


// _nav.setItems(accesses);
/* eslint-disable no-new */
